import React from "react";

import { NavLink, useParams, useLoaderData } from "react-router-dom";

import QuestionRow from "./QuestionRow";
import Breadcrumbs from "./Breadcrumbs";
import ResetAnswersButton from "./ResetAnswersButton";

const QuestionsPage = () => {
  let { categoryParam, topicParam } = useParams();
  const {questions} = useLoaderData();

  if (Object.entries(questions).length === 0) {
    return (
      <div>
        <Breadcrumbs category={categoryParam} topic={topicParam} />
        <main>
          <div className="alert alert-danger" role="alert">
            No such topic: {topicParam}.
          </div>
        </main>
      </div>
    );
  }

  return (
    <div>
      <Breadcrumbs category={categoryParam} topic={topicParam} />
      <main>
        <div className="row g-0">
          <div className="col d-grid gap-2">
            <NavLink
              className="btn btn-outline-primary"
              to={`/${categoryParam}/${topicParam}/quiz`}
            >
              {`Start ${topicParam} Quiz`}
            </NavLink>
          </div>
          <div className="col d-grid gap-2">
            <NavLink
              className="btn btn-outline-primary"
              to={`/${categoryParam}/${topicParam}/exam`}
            >
              {`Start ${topicParam} Exam`}
            </NavLink>
          </div>
        </div>
        <div className="list-group list-group-flush">
          {Object.entries(questions).map(
            ([questionID, value]) => (
              <QuestionRow key={questionID} questionID={questionID} />
            )
          )}
        </div>
        <ResetAnswersButton
          category={categoryParam}
          topic={topicParam}
          className="btn btn-outline-danger"
        />
      </main>
    </div>
  );
};

export default QuestionsPage;
